import { useParamsContext } from '../../../contexts/ParamsContext';
import AssinaturasForm from './Form';
import AssinaturasList from './List/List';
import AssinaturaDetalhe from './AssinaturaDetalhe';

export default function Assinaturas() {
    const { action } = useParamsContext();

    switch (action) {
        case 'add': {
            return <AssinaturasForm />;
        }
        case 'periodos':
        case 'recorrencias': {
            return <AssinaturaDetalhe />;
        }
        case 'list':
        default:
            return <AssinaturasList />;
    }
}
